import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-race-details-panel',
    templateUrl: './race-details-panel.component.html',
    styleUrls: ['./race-details-panel.component.scss'],
    standalone: false
})
export class RaceDetailsPanelComponent {

  @Input() panelStatus: string | undefined;
  @Input() panelId: string | undefined;
  @Input() isUsed: string | undefined;
  @Input() disabled: boolean = true;
}
